<template>
 <div class="page">
    <login-navigator></login-navigator>
    <logo-header></logo-header>
    <section class="main">
      <div class="connect-wrap">
        <h5>联系我们</h5>
        <div class="info">
          <p>公司电话：0757-87911933</p>
          <p>公司邮箱：hr@yolewa.com</p>
          <p>公司地址：广东省广州市越秀区东宝大厦601</p>
        </div>
      </div>
      <div class="road-wrap">
        <h5>推荐线路</h5>
        <p>动物园地铁站/杨箕地铁站--步行至东宝大厦&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;或乘坐B4/185/350/189/52等公交车</p>
        <div class="pic-wrap">
          <img src="../assets/map.png" alt="">
        </div> 
      </div>
    </section>
 </div>
</template>

<script>
import LoginNavigator from "@/components/LoginNavigator";
import LogoHeader from "@/components/LogoHeader";
export default {
  data() {
    return {};
  },
  components: {
    LoginNavigator,
    LogoHeader
  }
};
</script>

<style scoped>
.page {
  background: #f5f5f5;
}
.main {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 100px;
  background: #fff;
}
.main .connect-wrap {
  padding: 31px 33px 35px 33px;
}
.main .connect-wrap h5 {
  color: #333;
  font-size: 20px;
}
.main .connect-wrap .info {
  width: 100%;
  padding-left: 21px;
  margin-top: 22px;
  box-sizing: border-box;
  background: #f5f5f5;
}
.main .connect-wrap .info p {
  font-size: 20px;
  color: #333;
  margin-bottom: 47px;
}
.main .connect-wrap .info p:first-child {
  padding-top: 37px;
}
.main .connect-wrap .info p:last-child {
  padding-bottom: 42px;
}
.main .road-wrap {
  padding: 31px 33px 35px 33px;
}
.main .road-wrap h5 {
  color: #333;
  font-size: 20px;
}
.main .road-wrap p {
  margin-top: 20px;
}
.main .road-wrap .pic-wrap {
  width: 900px;
  height: 400px;
  margin-top: 20px;
  background: #f5f5f5;
}
.main .road-wrap .pic-wrap img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/connectUs.vue